<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Carrinho</p>
      <button type="button" class="delete" @click="$parent.close()" />
    </header>

    <section class="modal-card-body">
      <p class="adyen-id" v-if="merchantReference">
        <b>ID Adyen: </b>
        {{ merchantReference }}
      </p>

      <p class="transaction-id">
        <b>ID transação: </b>
        {{ transaction._id }}
      </p>
      <br />

      <p v-for="item in transaction.cart.items" :key="item._id">
        {{ `${item.quantity} x R$${formatMoney(item.price)} - ${item.name}` }}
      </p>

      <hr />

      <p>
        <b>Total: </b>
        {{ `R$${formatMoney(transaction.cart.totalValue)}` }}
      </p>

      <div v-if="transaction.vending && transaction.vending.vendingLog">
        <hr />
        <b>
          Log da entrega:
          {{ transaction.vending.vendingLog.length === 0 ? "-" : "" }}
        </b>

        <br /><br />

        <p v-for="log in transaction.vending.vendingLog" :key="log.logDate">
          {{ `${log.logDate} - ${log.description}` }}
          {{
            log.item ? ` - ${log.item.name} [slot ${log.item.slots[0]}]` : ""
          }}
        </p>
      </div>
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Fechar
      </button>
    </footer>
  </div>
</template>

<script>
import { mask } from "../../../mixins/mask";

export default {
  props: ["transaction"],

  mixins: [mask],

  computed: {
    merchantReference() {
      return this.transaction.details.provider === "adyen"
        ? (this.transaction.details.format === "ecommerce" ||
            this.transaction.details.format === "googlepay" ||
            this.transaction.details.format === "applepay") &&
          this.transaction.adyen &&
          this.transaction.adyen.paymentJSON
          ? this.transaction.adyen.paymentJSON.reference
          : this.transaction.details.format === "terminal" &&
            this.transaction.adyen &&
            this.transaction.adyen.paymentJSON &&
            this.transaction.adyen.paymentJSON.SaleToPOIRequest &&
            this.transaction.adyen.paymentJSON.SaleToPOIRequest
              .PaymentRequest &&
            this.transaction.adyen.paymentJSON.SaleToPOIRequest.PaymentRequest
              .SaleData &&
            this.transaction.adyen.paymentJSON.SaleToPOIRequest.PaymentRequest
              .SaleData.SaleTransactionID
          ? this.transaction.adyen.paymentJSON.SaleToPOIRequest.PaymentRequest
              .SaleData.SaleTransactionID.TransactionID
          : null
        : null;
    }
  }
};
</script>

<style scoped>
hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.adyen-id {
  text-align: center;
  padding-bottom: 1rem;
}
.transaction-id {
  text-align: center;
  padding-bottom: 1rem;
  border-bottom: 1px dashed #dbdbdb;
}
</style>
